import { cn } from '@/lib/utils'

interface SidebarProps {
  items: {
    label: string
    icon: React.ElementType
    value: 'dashboard' | 'users'
  }[]
  activeTab: 'dashboard' | 'users'
  onSelect: (value: 'dashboard' | 'users') => void
}

export function Sidebar({ items, activeTab, onSelect }: SidebarProps) {
  return (
    <aside className="w-64 border-r bg-white p-4">
      <h2 className="mb-4 text-lg font-semibold">Menu</h2>
      <nav className="space-y-2">
        {items.map((item) => (
          <button
            key={item.value}
            onClick={() => onSelect(item.value)}
            className={cn(
              'hover:bg-muted flex w-full items-center gap-2 rounded-md p-2 text-left',
              activeTab === item.value && 'bg-muted font-medium',
            )}
          >
            <item.icon className="h-4 w-4" />
            {item.label}
          </button>
        ))}
      </nav>
    </aside>
  )
}
